





import {Component, Prop} from "vue-property-decorator"
import AbpBase from "../../../../lib/abpbase"

@Component
export default class Month extends AbpBase{
	@Prop({type:Object,default:[]}) data:any
	columns = [
		{
			title: '类别编号',
			key: 'typeId'
		},
		{
			title: '患者姓名',
			key: 'patientName'
		},
		{
			title: '透析开始时间',
			key: 'startDate'
		},
		{
			title: '透析结束时间',
			key: 'endDate'
		},
		{
			title: '预计透析时长',
			key: 'predictDuration'
		},
		{
			title: '实际透析时长',
			key: 'actualDuration'
		},
		{
			title: '提前透析时长',
			key: 'advanceDuration'
		},
		{
			title: '提前下机原因',
			key: 'reason'
		}
	]

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/abnormal/parts/month.vue